import axios from './axios';
import SETTINGS from '../settings'
export default {
    getQuizzes(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/quiz`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getQuiz(id, params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/quiz/${id}`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    submitQuiz(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/userquiz`, payload ).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}